// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__wwlqg","rootCenter":"LoadMoreObserver_rootCenter__LSV7G","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__ayBct"};